var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('img',{class:_vm.classByRarity,attrs:{"src":_vm.operator.imgSrc}}),_c('OparatorCard',{staticClass:"tip-detail",attrs:{"operator":this.operator}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }